import { forwardRef } from 'react'
import { Link as CoreLink, LinkProps as CoreLinkProps } from '@perk-ui/core'
import { Link as RouterLink, LinkProps } from 'react-router-dom'

// related but not necessary: https://github.com/mui-org/material-ui/issues/16846
export type AppLinkProps = Omit<CoreLinkProps, 'component'> & LinkProps

/**
 * A Link integrated with ReactRouter behavior for in-app navigation.
 */
const AppLink = forwardRef<HTMLAnchorElement, AppLinkProps>(
  ({ children, to, ...rest }, ref) => (
    <CoreLink ref={ref} component={RouterLink} to={to} {...rest}>
      {children}
    </CoreLink>
  ),
)

AppLink.displayName = 'AppLink'

export default AppLink
